export const taskColors = ['#9DA1AC', '#22B7D7', '#ECD71F', '#F16767', '#FC67FF', '#CE66F1'];
